import { Spin, Tabs } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import OverviewDetails from './overview-details'
import EducationTab from './education-tab'
import ExperienceList from './experience-list'
import { useDispatch, useSelector } from 'react-redux'
import { candidateById, setCandidateId } from '../store/candidate.slice'
import { useLocation, useParams } from 'react-router-dom'
import ProjectTab from './project-tab'
import { PRIVATE_ROUTES } from '../../../routes'
import { loginState } from '../../login/login.slice'
import { getTalentAccess } from '../../../helpers/reportsPermission'
import styles from '../candidate.module.css'

const CandidateFormTab = () => {
    const dispatch = useDispatch()
    const [activeTab, setActiveTab] = useState('OVERVIEW')
    const [showEductionForm, setShowEducationForm] = useState(false)
    const [ShowExperienceForm, setShowExperienceForm] = useState(false)
    const [showProjectForm, setShowProjectForm] = useState(false)

    const { userProfile } = useSelector(loginState)
    const talentAccess = useMemo(
        () => getTalentAccess(userProfile),
        [userProfile]
    )

    const { candidateDetails, candidateId, candidateDetailLoading } =
        useSelector((state) => state.candidateSlice)
    // Reuse existing convertToUser read-only UI when user lacks edit permission
    const editableStatus = talentAccess.canEdit
        ? candidateDetails?.status
        : 'convertToUser'

    const { id } = useParams()
    const pathName = useLocation()
    const getCandidateById = async (id) => {
        try {
            dispatch(candidateById({ id, activeTab }))
        } catch (error) {
            console.log('🚀 ~ getCandidateById ~ error:', error)
        }
    }
    useEffect(() => {
        if (pathName.pathname === PRIVATE_ROUTES.candidate.create) {
            if (candidateId) {
                getCandidateById(candidateId)
            }
        } else if (id) {
            dispatch(setCandidateId(id))
            getCandidateById(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, id])

    const handleChangeTab = (tab) => {
        setActiveTab(tab)

        if (tab !== 'EDUCATION') {
            setShowEducationForm(false)
        }

        if (tab !== 'EXPERIENCE') {
            setShowExperienceForm(false)
        }

        if (tab !== 'PROJECTS') {
            setShowProjectForm(false)
        }
    }

    const tabs = [
        {
            key: 'OVERVIEW',
            label: 'Overview',
            children: (
                <OverviewDetails
                    currantData={candidateDetails}
                    activeTab={activeTab}
                    status={editableStatus}
                />
            ),
        },
        {
            key: 'EDUCATION',
            label: 'Education',
            disabled: candidateId == null,
            children: (
                <EducationTab
                    currantData={candidateDetails}
                    activeTab={activeTab}
                    showForm={showEductionForm}
                    setShowForm={setShowEducationForm}
                    candidateId={candidateId}
                    status={editableStatus}
                />
            ),
        },
        {
            key: 'EXPERIENCE',
            label: 'Experience',
            disabled: candidateId == null,
            children: (
                <ExperienceList
                    currantData={candidateDetails}
                    activeTab={activeTab}
                    showForm={ShowExperienceForm}
                    setShowForm={setShowExperienceForm}
                    candidateId={candidateId}
                    status={editableStatus}
                />
            ),
        },
        {
            key: 'PROJECTS',
            label: 'Projects',
            disabled: candidateId == null,
            children: (
                <ProjectTab
                    currantData={candidateDetails}
                    activeTab={activeTab}
                    showForm={showProjectForm}
                    setShowForm={setShowProjectForm}
                    candidateId={candidateId}
                    status={editableStatus}
                />
            ),
        },
    ]

    return (
        <Spin
            spinning={Boolean(candidateDetailLoading)}
            className={styles.tabContentSpin}
        >
            <Tabs
                className={styles.formTabs}
                defaultActiveKey={activeTab}
                activeKey={activeTab}
                onChange={(activeKey) => {
                    handleChangeTab(activeKey)
                }}
                style={{
                    width: '100%',
                }}
                items={tabs}
            />
        </Spin>
    )
}

export default CandidateFormTab
